import React from 'react';
import {PropTypes} from 'prop-types';

const disabledCss = 'disabled';

const BottomPager = (props) => {
  let totalPages;
  let startPage = 1;
  let endPage;
  let pageSetStart;
  let pageSetEnd;

  const _onChange = (event, page) => {
    event.preventDefault();
    if (page >= 1 && page <= totalPages && page !== props.currentPage) {
      props.onChange(page);
    }
  };

  const link = (page, text) => (
    <a tabIndex="-1" onClick={e => _onChange(e, page)}>{text}</a>
  );

  const buildPagingButton = (disabled, title, dataPage, currentPageCalc, iconClass, automationControlType) => {
    const css = disabled && disabledCss;
    return (
      <a data-automation-id={`paging-control-${automationControlType}`}
        title={title}
        className={`link ${css}`}
        data-page={dataPage}
        tabIndex="-1"
        onClick={e => _onChange(e, currentPageCalc)}>
        <i className={`${iconClass} size-small`} />
      </a>
    );
  };

  const renderFirstPageButton = disabled =>
    buildPagingButton(disabled, 'Go to the first page', 1, 1, 'icon-first', 'first');

  const renderPrevPageButton = disabled =>
    buildPagingButton(disabled, 'Go to the previous page', 1, props.currentPage - 1, 'icon-back', 'back');

  const renderNextPageButton = disabled =>
    buildPagingButton(disabled, 'Go to the next page', 2, props.currentPage + 1, 'icon-forward', 'forward');

  const renderLastPageButton = disabled =>
    buildPagingButton(disabled, 'Go to the last page', 3, totalPages, 'icon-last', 'last');

  const renderPagerButtons = () => {
    const buttons = [];

    if (startPage > 1) {
      const pageNumber = (startPage - 1);
      buttons.push(<li data-automation-id={`page-link-${pageNumber}`} key={pageNumber}>{link(pageNumber, '...')}</li>);
    }

    for (let i = startPage; i <= endPage; i += 1) {
      if (i === props.currentPage) {
        buttons.push(<li data-automation-id={`page-link-${i}`} key={i} className="selected"><span>{i}</span></li>);
      } else {
        buttons.push(<li data-automation-id={`page-link-${i}`} key={i}>{link(i, i)}</li>);
      }
    }

    if (endPage < totalPages) {
      const pageNumber = (endPage + 1);
      buttons.push(<li data-automation-id={`page-link-${pageNumber}`} key={pageNumber}>{link(pageNumber, '...')}</li>);
    }

    return (
      <ul>
        {buttons}
      </ul>
    );
  };

  const calculatePageData = () => {
    let remainder;

    totalPages = Math.ceil((props.itemCount || 0) / props.pageSize);

    if (props.currentPage > props.buttonCount) {
      remainder = (props.currentPage % props.buttonCount);

      startPage = (remainder === 0) ? (props.currentPage - props.buttonCount) + 1
        : (props.currentPage - remainder) + 1;
    }

    endPage = Math.min((startPage + props.buttonCount) - 1, totalPages);

    pageSetStart = ((props.currentPage - 1) * props.pageSize) + 1;
    pageSetEnd = Math.min(props.currentPage * props.pageSize, props.itemCount);
  };

  calculatePageData();

  const firstAndPrevPageDisabled = props.currentPage === 1 ? 'disabled' : null;
  const lastAndNextPageDisabled = props.currentPage === totalPages;

  return (
    <div className="table-pager type-rightalign" data-role="pager" style={props.style}>
      {renderFirstPageButton(firstAndPrevPageDisabled)}
      {renderPrevPageButton(firstAndPrevPageDisabled)}
      {renderPagerButtons()}
      {renderNextPageButton(lastAndNextPageDisabled)}
      {renderLastPageButton(lastAndNextPageDisabled)}
      <span data-automation-id="paging-control-text" className="info">{pageSetStart} - {pageSetEnd} of {props.itemCount} {props.itemsName}</span>
    </div>
  );
};

BottomPager.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  itemCount: PropTypes.number.isRequired,
  buttonCount: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  itemsName: PropTypes.string
};

BottomPager.defaultProps = {
  buttonCount: 10,
  pageSize: 10,
  style: {},
  itemsName: 'items'
};

export default BottomPager;